import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const status = {
    0: { name: 'Devuelto' },
    1: { name: 'Prestado' }
}

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getEquipments = async (dataOrigen, refrescar, api, token, body, config) => {
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.equipments.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    const response = await axios(configws)
    data = { equipments: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.equipments.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(equipment => {

      return (
        (
          equipment.code.toLowerCase().includes(queryLowered) ||
          equipment.name.toLowerCase().includes(queryLowered) ||
          (equipment.descripcion && equipment.descripcion.toLowerCase().includes(queryLowered) : false) ||
          (equipment.assignment_to && equipment.assignment_to.toLowerCase().includes(queryLowered) : false) ||
          (equipment.loan_status && status[equipment.loan_status].name.toLowerCase().includes(queryLowered) : false)
        )
      )
  })

  return [
    200,
    {
      allData: data.equipments,
      total: filteredData.length,
      equipments: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of equipments
// ------------------------------------------------

let dataequipments = { equipments: [], startDate: '', endDate: ''}

mock.onGet('/apps/equipments').reply(async config => {
  const user = getUserData()

  if (config.reset) {
    dataequipments = { equipments: [], startDate: '', endDate: ''}
  }

  const body = {
    office_id:     user.usercoc.office_id
  }

  const result = await getEquipments(dataequipments, 1, GetApiCOC('getlistEquipment'), user.token, body, config)

  dataequipments = { equipments: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  return result
})

// ------------------------------------------------
// Post: Add equipments
// ------------------------------------------------
mock.onPost(/\/api\/equipments\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertEquipment'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// Post: delete equipments
// ------------------------------------------------
mock.onPost(/\/api\/deleteEquipment\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('deleteEquipment'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})